export enum Step {
  CREATE_ACCOUNT = 'create_account',
  LOGIN = 'login',
  ALREADY_LOGGED_IN = 'already_logged_in',
}
